// extracted by mini-css-extract-plugin
export default {"titleStyle":"reembolso_titleStyle__qTyyC","rowStyle":"reembolso_rowStyle__f4TH5"};